import React from "react";

export const SmsIntegrationDetailContext = React.createContext(null);
export const useSmsIntegrationDetailContext = () => {
  const context = React.useContext(SmsIntegrationDetailContext);

  if (!context) throw new Error("SMS Integration Detail Context not provided!");

  return context;
};